<template>
  <div class="add-device_Container">
    <el-input placeholder="Filter keyword" v-model="filterText">
    </el-input>
    <el-tree class="filter-tree" :data="data" :props="defaultProps"
             :filter-node-method="filterNode" ref="tree2" style="color: black"></el-tree>

    <el-form v-model="device">

      <el-form-item label="registration key">
        <div v-if="true" style="color: red">The key is not valid. Please check the key and try again</div>
        <el-row>
          <el-input v-model="device.registration">
            <template slot="append"><el-button type="primary">Check validation</el-button></template>
          </el-input>
        </el-row>
      </el-form-item>

      <el-form-item label="Device key">
        <el-row>
          <el-button >Generate Key</el-button>
          <el-button >Upload Key</el-button>
        </el-row>
      </el-form-item>

      <div>
        Location
      </div>
      <div style="text-align: center">
        <center style="width: 300px;height: 300px;background-color: #99a9bf;position: center;">
        </center>
      </div>



    </el-form>
    <el-row>
      <el-button @click="submit">Save</el-button>
      <el-button @click="cancel">Cancel</el-button>
    </el-row>
  </div>
</template>

<script>
    import ElForm from "element-ui/packages/form/src/form";
    import ElFormItem from "element-ui/packages/form/src/form-item";
    import ElButton from "element-ui/packages/button/src/button";
    import ElInput from "element-ui/packages/input/src/input";

    import Device from './../../../Class/Device'


    export default {
      components: {
        ElInput,
        ElButton,
        ElFormItem,
        ElForm},
      name: "add-device",
      watch: {
        filterText(val) {
          this.$refs.tree2.filter(val);
        }
      },
      data(){
        return {
          defaultProps: {
            children: 'children',
            label: 'label'
          },
          filterText: '',
          device: {
            type: '',
            Registration: '',
            date: Date.now(),
            coordinate: '',
          },
          data:[{
            id:1,
            label: 'GateWay1',
            children: [{
              id:11,
              label: 'Gateway 1-1',
              children: [{
                id:111,
                label: 'Sensor 1-1-1'},{
                id:112,
                label: 'Sensor 1-1-2'},{
                id:113,
                label: 'Sensor 1-1-3'}]},
              { id:12,
                label: 'Gateway 1-2',
                children: [{
                  id:121,
                  label: 'Sensor 1-2-1'},{
                  id:122,
                  label: 'Sensor 1-2-2'},{
                  id:123,
                  label: 'Sensor 1-2-3'}]
            }            ]
        },{
            id:2,
            label:'Forwarder 2',
            children:[{
              id:1,
              label:'GateWay 2-1'
            },{
              id:2,
              label:'GateWay 2-2'
            }]
          }]
      }},methods: {
        submit(){
          let tmp = new Device('location','name',this.device.type)
          tmp.addDevice();
          console.log('addDevice submit',this.device)
        },cancel(){
          console.log('cancel device')
        },handleNodeClick(data){
          console.log('data',data)
        },filterNode(value, data) {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import url("//unpkg.com/element-ui@2.2.2/lib/theme-chalk/index.css");
  *{
    color: black;
  }
  .itemChild{
    margin-left: 20px;
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/settings/Device/addDevice.vue